import { all, takeLeading } from 'redux-saga/effects';
import { api, commonApiSaga } from 'redux/helpers/api';
import history from 'providers/history';
import { takeLeadingPerKey } from 'redux/helpers/saga';
import types from './types';

export default function* collectionSagas() {
  yield all([
    takeLeading(types.getCollections, commonApiSaga, { apiFn: api.collections.index, workspaceId: true }),
    takeLeadingPerKey(types.getCollection, commonApiSaga, ({ payload }) => payload.collectionId, { apiFn: api.collections.show, workspaceId: true, onFailure: () => history.push('/manage/collections') }),
    takeLeadingPerKey(types.getPageCollections, commonApiSaga, ({ payload }) => payload.pageId, { apiFn: api.pages.collections, workspaceId: true }),
    takeLeadingPerKey(types.getEntries, commonApiSaga, ({ payload }) => payload.collectionId, { apiFn: api.collections.entries.index, workspaceId: true }),
    takeLeading(types.update, commonApiSaga, { apiFn: api.collections.update, workspaceId: true, successMessage: 'collection.updated' }),
  ]);
}
